import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

import { DeleteLeadsInput } from '../../../shared/models/lead/deleteLeads.input';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: []
})
export class DeleteModalComponent implements OnInit {

  get f(): any {
    return this.form.controls;
  }

  @ViewChild('content', { static: false }) content: Element;
  closeResult: string;
  idLeads: string[];
  comments: string;

  form: FormGroup;
  sending = false;

  static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    }

    if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    }

    return `with: ${reason}`;

  }

  constructor(
    private readonly leadComunicationService: LeadsComunicationService,
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toasterService: ToastService,
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    // TODO Fix bug with subscription not being correctly deleted on component destroy
    // For reference read this page https://stackoverflow.com/questions/53505872/angular-eventemitter-called-multiple-times
    this.modalsHandler.deleteModal.subscribe((ids: string[]) => {
      this.open(this.content);
      this.idLeads = ids;
    });

    this.form = this.formBuilder.group({
      comments: ['', Validators.required]
    });
  }

  open(content: any): void {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static', keyboard: false
    }).result.then(() => {
      this.deleteLeads();
    }, reason => {
      this.closeResult = `Dismissed ${DeleteModalComponent.getDismissReason(reason)}`;
    });
  }

  deleteLeads(): void {

    this.spinner.show();
    if (this.form.invalid) {
      this.spinner.hide();

      return;
    }

    this.bindForm();

    const deleteInput = new DeleteLeadsInput(this.idLeads, this.comments);
    this.leadService.deleteLeads$(deleteInput).subscribe(() => {
      this.sending = true;
      this.spinner.hide();
      this.toasterService
        .showToast(
          'success',
          'toaster.lead.deleted.success',
          'toaster.lead.deleted.success.body'
        );
      this.sending = false;
      this.leadComunicationService.launchReloadLeads();
    }, () => {
      this.spinner.hide();
      this.toasterService
        .showToast(
          'error',
          'toaster.lead.deleted.error',
          'toaster.lead.deleted.error.body'
        );
      this.sending = false;
    });
    this.modalService.dismissAll();
    this.resetForm();
  }

  bindForm(): void {
    this.comments = this.f.comments.value;
  }

  resetForm(): void {
    this.form.reset();
    this.comments = '';
  }
}
